import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const NETWORK_ERRORS = new Set(['Failed to fetch', 'Network Error', 'Load failed']);

const isNetworkError = (error) => {
  const msg = typeof error === 'string' ? error : (error?.message ?? '');
  return NETWORK_ERRORS.has(msg);
};

const PageError = ({ error, onRetry, variant = 'inline', subtitle: subtitleProp }) => {
  if (!error) return null;

  const network = isNetworkError(error);
  const title = network ? 'Connexion interrompue' : typeof error === 'string' ? error : error?.message;
  const subtitle =
    subtitleProp ?? (network ? 'Vos données sont intactes. Le serveur est temporairement inaccessible.' : null);

  const wrapperClass =
    variant === 'fullpage' ? 'min-h-screen flex items-start justify-center pt-[22vh]' : 'p-8 text-center';

  return (
    <div className={wrapperClass}>
      <div className="text-center">
        <AlertTriangle className="w-8 h-8 text-red-500 mx-auto mb-2" />
        <p className="text-red-600 font-semibold mb-1">{title}</p>
        {subtitle && <p className="text-gray-500 text-sm mb-4">{subtitle}</p>}
        {onRetry && (
          <Button variant="outline" onClick={onRetry} className="mt-3 gap-2">
            <RefreshCw className="w-4 h-4" />
            Réessayer
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageError;
